import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getPlantLevelConfigSlice = createApi(`GetPlantLevelConfigSlice`,"GET");

const GetPlantLevelConfigSlice = createSlice({
  name: 'GetPlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPlantLevelConfigSlice.reducer;